import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { useParams } from 'react-router'

// Store
import { actions } from 'core/store'

// Hooks
import { useUpdateDocument, useGetDocuments } from 'core/hooks/api'

// Styled Elements
import {
  Wrapper,
  SummaryWrapper,
  ColWrapper,
  FormWrapper,
  ButtonWrapper,
  Title,
  Error,
  Text,
} from './AiDocumentSummary.elements'

// Views
import { LoadingTablePlaceholder, Button, JsonField } from 'views/components'
// Layouts
import { AiDocumentUploadForm } from 'views/layouts'
import AiDocumentChunkTable from '../AiDocumentChunkTable'
// constants

// Map Redux Props
const mapStateToProps = (state) => state
const mapDispatchToProps = actions

function AiDocumentSummary(props) {
  const { actions } = props

  // Store
  const { setDocumentToDeleteID, toggleDeleteAiDocModalOpen } = actions

  // Local State
  const [disabled, setDisabled] = useState(true)
  const [origDocument, setOrigDocument] = useState()
  const [didSucceed, setDidSuceed] = useState()
  const [didFail, setDidFail] = useState()
  const [metadata, setMetadata] = useState({ key: 'value' })

  // Refs
  const formRef = useRef()

  // Hooks
  const { updateDocument, updateDocumentData, updateDocumentError, isUpdateDocumentLoading } = useUpdateDocument()
  const { getDocuments, getDocumentsData, isGetDocumentsLoading } = useGetDocuments()
  const { document_id } = useParams()

  // Functions
  const handleDelete = () => {
    setDocumentToDeleteID(document_id)
    toggleDeleteAiDocModalOpen()
  }
  const handleDocument = (data) => {
    if (data?.items?.length > 0) {
      const item = data?.items[0]
      setOrigDocument({ ...item })
      setMetadata(item?.core_metadata)
    }
  }
  const handleSubmit = () => {
    updateDocument({ ...formRef.current?.values, core_metadata: JSON.parse(metadata) })
  }
  const handleUploaded = (response) => {
    if (response) setDidSuceed(true)
  }
  const handleErr = (response) => {
    if (response) setDidFail(true)
  }
  const handleCancel = () => {
    setDisabled(true)
    formRef.current.setValues(origDocument)
    setMetadata(origDocument?.core_metadata)
  }

  // UseEffects
  useEffect(() => {
    getDocuments({ document_id })
  }, [])
  useEffect(() => {
    handleDocument(getDocumentsData)
  }, [getDocumentsData])
  useEffect(() => {
    handleUploaded(updateDocumentData)
  }, [updateDocumentData])
  useEffect(() => {
    handleErr(updateDocumentError)
  }, [updateDocumentError])
  return (
    <Wrapper>
      <SummaryWrapper>
        {isUpdateDocumentLoading && (
          <FormWrapper>
            <LoadingTablePlaceholder />
          </FormWrapper>
        )}
        {!didSucceed && !isUpdateDocumentLoading && !isGetDocumentsLoading && !didFail && origDocument && (
          <FormWrapper>
            <ColWrapper>
              <AiDocumentUploadForm formRef={formRef} viewMode={disabled} values={origDocument} />
            </ColWrapper>
            <ColWrapper>
              <JsonField
                rows="7"
                label="Metadata"
                id="metadata"
                initialValue={metadata}
                onChange={setMetadata}
                disabled={disabled}
              />
            </ColWrapper>
          </FormWrapper>
        )}
        {didSucceed && !isUpdateDocumentLoading && (
          <FormWrapper>
            <Title>Successfully Uploaded Document</Title>
            <Text>Please refresh the page</Text>
          </FormWrapper>
        )}
        {didFail && !isUpdateDocumentLoading && (
          <FormWrapper>
            <Error>An Error Occurred</Error>
            <Text>Please try again later</Text>
          </FormWrapper>
        )}

        {!didSucceed && !isUpdateDocumentLoading && !didFail && (
          <ButtonWrapper>
            <Button type="button" color="secondary" onClick={handleDelete}>
              Delete
            </Button>
            {disabled && (
              <Button type="button" variant="outlined" onClick={() => setDisabled(false)}>
                Edit
              </Button>
            )}
            {!disabled && (
              <>
                <Button type="button" variant="outlined" onClick={handleCancel}>
                  Cancel
                </Button>
                <Button type="button" onClick={handleSubmit}>
                  Save
                </Button>
              </>
            )}
          </ButtonWrapper>
        )}
      </SummaryWrapper>
      <AiDocumentChunkTable />
    </Wrapper>
  )
}

// Default Props
AiDocumentSummary.defaultProps = {
  ui: {},
  address: {},
  actions: {},
}

// Proptypes Validation
AiDocumentSummary.propTypes = {
  ui: PropTypes.shape({ isAiDocumentUploadModalOpen: PropTypes.bool }),
  address: PropTypes.shape({
    addressReportDetails: PropTypes.shape({
      address_id: PropTypes.string,
      address: PropTypes.string,
      chain: PropTypes.string,
    }),
  }),
  actions: PropTypes.shape({
    toggleDeleteAiDocModalOpen: PropTypes.func,
    setDocumentToDeleteID: PropTypes.func,
    setIsPageTableUpdated: PropTypes.func,

  }),
}

export default connect(mapStateToProps, mapDispatchToProps)(AiDocumentSummary)
